import {tagItemTemplatePrepaid, tagItemTemplateBranded, tagItemTemplate} from "./templates";
import {uuid, priceWithCommas} from "../../app/helper";
import {selector} from "./selector";
import {translate} from "../../app/localisation";
import TagOrderType from "../../enums/tag-order-type";
import CustomerType from "../../enums/customer-type";

const orderOptions = window.orderOptions;

var pricePerTag = 0;
var currency = '';
let customizationPrice = 0;

const initTags = function () {
    if (window.oldItems && Object.keys(window.oldItems).length > 0) {
        showErrors();
    } else {
        addTagRow(uuid(), TagOrderType.T4A);
    }

    calculateTotals();
};

const showErrors = () => {
    let number = 1;
    for (const [uuid, item] of Object.entries(window.oldItems)) {
        const itemErrors = {};
        for (const [key, msgs] of Object.entries(window.errors)) {
            // errors look like "items.uuid.field"
            if (key.startsWith(`items.${uuid}.`)) {
                const field = key.split('.').pop();
                itemErrors[field] = msgs;
            }
        }

        const tagItemHtml = getTagItemTemplate(number, uuid, item.type, item, itemErrors
        );
        $(selector.tagItemsContainer).append(tagItemHtml);

        number++;
    }
};

const getTagItemTemplate = (number, id, defaultChecked, values, errors) => {
    if (orderOptions.customizedTag) {
        return tagItemTemplateBranded(number, id, defaultChecked, values, errors)
    }
    if (orderOptions.prepaidTag) {
        return tagItemTemplatePrepaid(number, id, defaultChecked, values, errors);
    }
    return tagItemTemplate(number, id, defaultChecked, values, errors);

};
const addTagRow = function (uuid, defaultChecked) {
    const currentItemCount = $(selector.tagItems).length;
    const newItemNumber = currentItemCount + 1;
    const tagItemHtml = getTagItemTemplate(newItemNumber, uuid, defaultChecked);
    $(selector.tagItemsContainer).append(tagItemHtml);
    calculateTotals();
};
const handleTagTypeChange = function (event) {
    const radioInput = $(event.target);
    const container = radioInput.closest('.js_tag_item_container');
    const prepaidAmountWrapper = container.find(selector.prepaidAmountWrapper);

    if (radioInput.val() === 'pre-paid') {
        prepaidAmountWrapper.removeClass('d-none');
    } else {
        prepaidAmountWrapper.addClass('d-none');
        prepaidAmountWrapper.find(selector.prepaidAmount).val('');
    }
    calculateTotals();
};

const handleRemoveTag = function (event) {
    event.preventDefault();
    $(event.target).closest('.js_tag_item_container').remove();
    renumberTagItems();
    calculateTotals();
};

const renumberTagItems = function () {
    $(selector.tagItems).each(function (index) {
        const newNumber = index + 1;
        $(this).find('label:first').text(`${translate('order')['tag']} ${newNumber}`);
    });
};
const calculateTotals = function () {
    let totalTagCount = 0;
    let totalTagPrice = 0;
    let totalPrepaidAmount = 0;
    let totalCustomizedAmount = 0;
    let grandTotal = 0;

    $(selector.tagItems).each(function () {
        const container = $(this);
        const quantity = $(selector.tagItemsContainer).length || 0;
        const typeIsPrepaid = container.find(selector.radioBtnPrepaid).is(':checked');
        const customization = container.find(selector.customizedText).val();

        totalTagCount += quantity;

        let prepaidAmount = 0;
        if (typeIsPrepaid) {
            prepaidAmount = parseFloat(container.find(selector.prepaidAmount).val().replace(',', '.')) || 0;
        }
        if (customization !== undefined && customization.trim() !== '') {
            totalCustomizedAmount += customizationPrice;
        }

        totalPrepaidAmount += (prepaidAmount * quantity);
    });

    totalTagPrice = totalTagCount * pricePerTag;
    grandTotal = totalTagPrice + totalPrepaidAmount + totalCustomizedAmount;
    if ($(selector.deliveryPriceRow).is(':visible')) {
        grandTotal += orderOptions.payment.deliveryPrice;
    }

    $(selector.price).val(grandTotal);
    $(selector.total).val(grandTotal);

    $(selector.totalTagCount).text(totalTagCount);
    $(selector.totalTagPrice).text(priceWithCommas(totalTagPrice) + currency);
    if (orderOptions.prepaidTag) {
        $(selector.totalPrepaidAmount).text(priceWithCommas(totalPrepaidAmount) + currency);
    }
    if (orderOptions.customizedTag) {
        $(selector.totalCustomizedAmount).text(priceWithCommas(totalCustomizedAmount) + currency);
    }


    $(selector.grandTotalPrice).text(priceWithCommas(grandTotal) + currency);
};

const toggleCustomerType = function (e) {
    let customerType = parseInt($(e.target).val());

    if (customerType === CustomerType.INDIVIDUAL) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').show();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').hide();
    } else if (customerType === CustomerType.COMPANY) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').hide();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').show();
    } else {
        console.error('Undefined customer type');
    }
}

const paymentMethodChange = function (e) {
    if (orderOptions.payment.deliveryPrice > 0) {
        let selectedPayment = $(e.target).val();
        if (selectedPayment === 'manual') {
            $(selector.deliveryPriceRow).hide();
        } else {
            $(selector.deliveryPriceRow).show();
        }
        calculateTotals();
    }
}

const countryChanged = function (e) {
    let selectedCountry = $(e.target).val();

    if (selectedCountry === '') {
        pricePerTag = 0;
        currency = '';
        $(selector.selectedCurrency).val('');
        $(selector.deliveryNotification).hide();
        customizationPrice = 0;
    } else if (selectedCountry === 'RS') {
        $(selector.deliveryNotification).show();
        pricePerTag = parseFloat($(selector.pricePerTag).val());
        currency = ' RSD';
        $(selector.selectedCurrency).val('RSD');
        customizationPrice = orderOptions.customizedPrice;
    } else {
        $(selector.deliveryNotification).hide();
        pricePerTag = parseFloat($(selector.pricePerTagEur).val());
        currency = ' EUR';
        $(selector.selectedCurrency).val('EUR');
        customizationPrice = orderOptions.customizedPriceEur;
    }
    calculateTotals();
}


export {initTags, handleTagTypeChange, addTagRow, handleRemoveTag, calculateTotals, toggleCustomerType, paymentMethodChange, countryChanged, renumberTagItems};
